import Focus from '../../../types/enums/focus';
import useKeyboard from './useKeyboard';
import { store } from '../../../store/store';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { userSelector } from '../../../store/slices/user.slice';
import { useEffect, useRef } from 'react';
import {
  filterFocus,
  pushFocus,
  stackFocus,
} from '../../../store/slices/focus.slice';

function useMenu(focus: Focus | number | null, handleLeft = false) {
  const dispatch = useAppDispatch();
  const { isAnonymous } = useAppSelector(userSelector);
  const anonymousRef = useRef(isAnonymous);
  anonymousRef.current = isAnonymous;

  useEffect(() => {
    if (focus) {
      dispatch(stackFocus(focus));
    }
    return () => {
      focus && dispatch(filterFocus(focus));
    };
  }, []);

  if (handleLeft) {
    useKeyboard({
      canBeFocused: false,
      keyDownHandler: (key) => {
        if (key === 'LEFT') {
          dispatch(pushFocus(Focus.MENU));
        }
      },
    });
  }

  return (key?: string | number) => {
    switch (key) {
      case 'BACK':
      case 'LEFT':
        ![Focus.LOGIN, Focus.MENU].includes(focus as number) &&
          dispatch(pushFocus(Focus.MENU));
        break;
      case 'UP':
        const { app } = store.getState();
        app.status.login &&
          anonymousRef.current &&
          focus !== Focus.LOGIN &&
          dispatch(pushFocus(Focus.LOGIN));
        break;
    }
  };
}

export default useMenu;
